module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAACBSURBVDiNtZPJEYAwDAMFNCY6oRPUGaITSuEDM0AuMwz+5fBmnTjAHyFJ0b19JpkAZklLBNBVDOZjOEpyCTDkJm2bZAeAACaSq+0tbHAxIYCzlKxJFRCBNAEtSPIKAdjNoAl4nv5c/3yJRYOjF6rJRYM3jZQALtqWlNQcijef6XPs/HI+0wA1fv8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right-gray.png
// module id = 4THW
// module chunks = 0